<template>
  <div class="shoppe">
    <div class="query-form">
      <el-form label-position="right" label-width="90px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="Vendor ID">
                  <el-input type="number" v-model.number="queryForm.inputVendorId" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="店铺">
                  <el-select v-model="queryForm.vendorId" filterable clearable>
                    <el-option v-for="item in vendorList" :label="item.label" :value="item.value" :key="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button @click="search" type="primary">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div>
      <el-button type="primary" @click="showForm">新增配置</el-button>
    </div>
    <el-table :data="tableData">
      <el-table-column prop="vendorId" label="Vendor ID"></el-table-column>
      <el-table-column prop="vendorRealName" label="买手店"></el-table-column>
      <el-table-column prop="configBrandNames" label="品牌"></el-table-column>
      <el-table-column prop="configSeasonCodes" label="季节"></el-table-column>
      <el-table-column prop="configCategoryNames" label="品类"></el-table-column>
      <el-table-column prop="configTime" label="配置时间">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.configTime) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220">
        <template slot-scope="scope">
          <el-link type="primary" @click="editItem(scope.row)">编辑</el-link>
          <el-link type="primary" class="ml10" @click="removeItem(scope.row)">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <el-dialog append-to-body :title="form.vendorImProductConfigId ? '新增' : '编辑'" :visible.sync="dialogVisible" width="700px">
      <el-form ref="form" :model="form" label-width="150px">
        <el-form-item label="买手店名称" prop="vendorId" :rules="[{ required: true, message: '请选择账户名称' }]">
          <el-select v-model="form.vendorId" :disabled="form.vendorImProductConfigId" filterable>
            <el-option v-for="item in vendorList" :label="item.label" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="季节" prop="configSeasonCodes" :rules="[{ required: true, message: '请选择季节' }]">
          <el-select v-model="form.configSeasonCodes" filterable multiple>
            <el-option v-for="item in seasonList" :label="item" :value="item" :key="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品牌" prop="configBrandIds" :rules="[{ required: true, message: '请选择品牌' }]">
          <BrandSelect
            v-model="form.configBrandIds"
            :data="brandList"
            multiple
            collapse-tags
            filterable
            clearable
          ></BrandSelect>
        </el-form-item>
        <el-form-item label="" v-if="brandTags.length > 0">
          <el-tag v-for="(tag, index) in brandTags" :key="tag.value" style="margin:0 10px 5px 0;" closable @close='closeTag(index, "configBrandIds")'>
            {{ tag.label }}
          </el-tag>
        </el-form-item>
        <el-form-item label="品类" prop="configCategoryIds" :rules="[{ required: true, message: '请选择品类' }]">
          <el-cascader
            v-model="form.configCategoryIds"
            :options="categoryList"
            :props="optionProps"
            collapse-tags
            clearable
          ></el-cascader>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getVendorProductConfigList,
  addVendorProductConfig,
  updateVendorProductConfig,
  deleteVendorProductConfig,
  getSeasonCodes,
  getPoolVendorList,
} from "./api";
import {
  getBrandList,
} from '../seller/api';
import {
  getCategory,
} from '../../api/mapping';
import utils from '@/utils/util';
import BrandSelect from '../shared/brandSelect.vue';

export default {
  components: {
    BrandSelect,
  },
  data() {
    return {
      vendorList: [],
      seasonList: [],
      brandList: [],
      categoryList: [],
      optionProps: {
        value: 'categoryId',
        children: 'children',
        label: 'chineseName',
        expandTrigger: "hover",
        emitPath: false,
        checkStrictly: false,
        multiple: true
      },
      queryForm: {
        inputVendorId: null,
        vendorId: null,
        pageNo: 1,
        pageSize: 25,
      },
      tableData: [],
      total: 0,
      dialogVisible: false,
      form: {
        vendorImProductConfigId: null,
        vendorId: null,
        configSeasonCodes: [],
        configBrandIds: [],
        configCategoryIds: [],
      },
    };
  },
  computed: {
    brandTags() {
      return this.form.configBrandIds.map(item => {
        const brand = this.brandList.find(item2 => item2.value === item);
        return brand;
      })
    },
  },
  mounted() {
    getPoolVendorList().then(res => {
      if (res.data) {
        this.vendorList = res.data.map(item => ({
          label: item.vendorName,
          value: item.vendorId,
        }));
      }
    })
    getBrandList().then(res => {
      this.brandList = (res.data || []).map(item => ({
        label: item.englishName,
        value: item.brandId
      }));
    });
    getCategory().then(res => {
      if (res.data && res.data.data) {
        this.categoryList = res.data.data
      }
    })
    getSeasonCodes().then(res => {
      this.seasonList = (res.data || []).map(item=>item.seasonCode)
    })
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.inputVendorId = null;
      this.queryForm.vendorId = null;
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      getVendorProductConfigList({
        ...this.queryForm,
        vendorId: this.queryForm.inputVendorId || this.queryForm.vendorId,
      }).then(res => {
        if (res.data) {
          this.total = res.data.total;
          this.tableData = res.data.list;
        }
      });
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.repeatSave) {
            this.repeatSave = true;
            let request = addVendorProductConfig;
            if (this.form.vendorImProductConfigId) {
              request = updateVendorProductConfig;
            }
            request(this.form).then(res => {
              this.repeatSave = false;
              if (res.success) {
                this.$message.success(this.form.vendorImProductConfigId ? '修改成功' : '新增成功');
                this.dialogVisible = false;
                this.getTableData();
              } else {
                this.$message.error(res.message || '系统异常，请稍后再试');
              }
            }).catch((err) => {
              this.repeatSave = false;
            })
          }
        } else {
          this.$message.error('请完善信息');
          return false;
        }
      });
    },
    showForm() {
      this.form.vendorImProductConfigId = null;
      this.form.vendorId = null;
      this.form.configSeasonCodes = [];
      this.form.configBrandIds = [];
      this.form.configCategoryIds = [];
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      })
    },
    editItem(row) {
      this.form.vendorImProductConfigId = row.vendorImProductConfigId;
      this.form.vendorId = row.vendorId;
      this.form.configSeasonCodes = row.configSeasonCodeList || [];
      this.form.configBrandIds = row.configBrandIds || [];
      this.form.configCategoryIds = row.configCategoryIds || [];
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      })
    },
    removeItem(row) {
      this.$confirm(`确认删除这条配置吗?`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteVendorProductConfig({
          vendorImProductConfigId: row.vendorImProductConfigId,
        }).then(() => {
          this.$message({
            type: 'success',
            message: '操作成功!'
          });
          this.getTableData();
        })
      }).catch(() => {});
    },
    dateFormat(time) {
      if (!time) {
        return '';
      }
      return utils.dateFormat(new Date(time), 'yyyy-MM-dd hh:mm:ss');
    },
    closeTag(index, field) {
      this.form[field].splice(index, 1);
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.mb10 {
  margin-bottom: 10px;
}
.store-wrap {
  max-height: 500px;
  overflow: auto;
}
.store-list {
  display: flex;
  margin-bottom: 2px;
  border: 1px solid #DCDFE6;
  border-radius: 5px;

  .store-name {
    flex: 0 0 auto;
    width: 150px;
    padding: 10px;
    border-right: 1px solid #DCDFE6;
  }
  .store-stocklocation-list {
    padding: 10px;
  }
}
.sl-group {
  display: flex;
  flex-wrap: wrap;

  .sl-item {
    margin-right: 10px;
    margin-top: 10px;
    padding: 0 5px;
    line-height: 30px;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
  }
  .icon-close:hover {
    color: #409EFF;
  }
}
.vendor-name {
  white-space:nowrap;
  text-overflow:ellipsis;
  overflow:hidden; 
}
</style>
